import styled from 'styled-components';

export const Content = styled.div`
  text-align: center;

  & .content {
    display: flex;
    justify-content: space-between;
    grid-gap: 60px;
  }

  p.description {
    color: var(--color-text);
    margin: 30px 0;
  }

  .buttonContainer {
    width: 300px;
    max-width: 100%;
    display: flex;
    grid-gap: 10px;
    justify-content: center;
    margin: 0 auto;
  }
`;
